/** Entrenos, ejercicios, modales — español */
export const WORKOUTS_UI_ES = {
  'workout.suggestAddToDict': '+ Añadir «{name}» al diccionario',

  'workout.classic.bench': 'Press de banca con barra',
  'workout.classic.squatBarbell': 'Sentadilla con barra',
  'workout.classic.deadlift': 'Peso muerto',
  'workout.classic.ohp': 'Press militar con barra',
  'workout.classic.pullUps': 'Dominadas',
  'workout.classic.pushUps': 'Flexiones',
  'workout.classic.squats': 'Sentadillas',
  'workout.classic.lunges': 'Zancadas',
  'workout.classic.latPulldown': 'Jalón al pecho',
  'workout.classic.dbRow': 'Remo con mancuernas',
  'workout.classic.latRaise': 'Elevaciones laterales',
  'workout.classic.barbellCurl': 'Curl con barra',
  'workout.classic.tricepPushdown': 'Extensión de tríceps en polea',
  'workout.classic.calfRaise': 'Elevación de gemelos',
  'workout.classic.crunches': 'Abdominales',
  'workout.classic.plank': 'Plancha',
  'workout.classic.burpee': 'Burpee',
  'workout.classic.other': 'Otro',

  'workout.err.historyLoad': 'No se pudo cargar el historial del ejercicio',
  'workout.err.gymNameRequired': 'Indica el nombre del gimnasio',
  'workout.err.trainerForLocation': 'No se pudo identificar al entrenador para añadir la ubicación',
  'workout.err.createdGymId': 'No se obtuvo el ID del gimnasio nuevo',
  'workout.toast.gymAdded': 'Gimnasio añadido',
  'workout.err.gymAddFailed': 'No se pudo añadir el gimnasio. Inténtalo de nuevo.',
  'workout.confirm.deleteWorkoutSimple': '¿Eliminar este entreno?',
  'workout.err.deleteWorkoutFailed': 'No se pudo eliminar el entreno',
  'workout.toast.recurrenceDuplicateSlot': 'Ese día de la semana y hora ya están elegidos',
  'workout.err.clientWorkoutNotFound': 'No hay entreno para este cliente a la hora indicada',
  'workout.err.openClientWorkoutNoHandler': 'No se puede abrir el entreno del cliente (falta el controlador)',
  'workout.err.openClientWorkout': 'No se pudo abrir el entreno del cliente',
  'workout.err.groupExerciseTargets': 'No se pudieron resolver los entrenos de los participantes para añadir el ejercicio',
  'workout.toast.exerciseAddedPartial': 'No se añadió a todos: {ok}/{total}',
  'workout.toast.exerciseAddedAll': 'Ejercicio añadido para todos los participantes ({n})',
  'workout.alert.pickExerciseName': 'Elige o escribe el nombre del ejercicio',
  'workout.alert.setRepsInvalid': 'Serie {n}: indica repeticiones válidas (solo enteros)',
  'workout.alert.setWeightInvalid':
    'Serie {n}: indica un peso válido (decimal con punto o coma) o déjalo vacío',
  'workout.success.exerciseAdded': '¡Ejercicio añadido!',
  'workout.err.exerciseAdd': 'Error al añadir el ejercicio',
  'workout.alert.planNoExercises': 'Este plan no tiene ejercicios',
  'workout.err.participantWorkoutsPlan': 'No se pudieron resolver los entrenos para añadir el plan',
  'workout.success.planExercisesAdded': 'Se añadieron {n} ejercicios del plan «{name}»',
  'workout.err.planExercisesAdd': 'Error al añadir ejercicios del plan',
  'workout.alert.planExercisesAllDuplicate': 'Todos los ejercicios del plan ya están en este entreno',
  'workout.success.planExercisesAddedCount': 'Se añadieron {n} ejercicios del plan «{name}»',
  'workout.alert.planExercisesAddFail':
    'No se pudieron añadir los ejercicios del plan. Revisa la conexión e inténtalo de nuevo.',
  'workout.alert.planExercisesAllDup2': 'Todos los ejercicios del plan ya estaban añadidos.',
  'workout.err.unknown': 'Error desconocido',
  'workout.err.planExercisesWithMsg': 'Error al añadir ejercicios del plan: {msg}',
  'workout.confirm.replacePlanExercises': '¿Sustituir todos los ejercicios por el plan seleccionado?',
  'workout.err.deleteExistingExercises': 'Error al quitar los ejercicios actuales',
  'workout.success.addedNExercises': 'Se añadieron {n} ejercicios',
  'workout.err.addExercisesBulk': 'Error al añadir ejercicios',
  'workout.alert.enterExerciseName': 'Escribe el nombre del ejercicio',
  'workout.alert.duplicateExerciseInWorkout': 'Ya hay un ejercicio con ese nombre en este entreno',
  'workout.success.exerciseUpdated': '¡Ejercicio actualizado!',
  'workout.err.exerciseUpdate': 'Error al actualizar el ejercicio',
  'workout.err.exerciseDelete': 'Error al eliminar el ejercicio',
  'workout.err.cancelSeriesNoClient': 'No se puede cancelar la serie: el entreno no tiene cliente',
  'workout.toast.cancelledN': 'Se cancelaron {n} entrenos',
  'workout.toast.workoutCancelled': 'Entreno cancelado',
  'workout.err.cancelFailedN': 'No se pudieron cancelar {n} entrenos',
  'workout.err.cancelNoConfirm': 'No se pudo cancelar el entreno: respuesta del servidor poco clara.',
  'workout.err.cancelWorkout': 'Error al cancelar el entreno',
  'workout.err.withMessage': 'Error: {msg}',
  'workout.err.markSkipped': 'No se pudo marcar como omitido',
  'workout.err.skipMark': 'Error al marcar como omitido',
  'workout.err.restoreWorkout': 'Error al restaurar el entreno',
  'workout.success.commentSaved': 'Comentario guardado',
  'workout.success.commentRemoved': 'Comentario eliminado',
  'workout.err.commentSave': 'Error al guardar el comentario',
  'workout.err.locationUpdate': 'No se pudo actualizar la ubicación',
  'workout.err.locationDelete': 'Error al quitar la ubicación',
  'workout.err.commentDelete': 'Error al eliminar el comentario',
  'workout.alert.fillDateTime': 'Completa fecha y hora',
  'workout.err.transferNoConfirm': 'No se pudo reprogramar: respuesta del servidor poco clara.',
  'workout.alert.timeBusy': 'Ese horario está ocupado. Conflictos: {clients}',
  'workout.alert.otherWorkouts': 'otros entrenos',
  'workout.alert.sameClientConflict': 'Este cliente ya tiene un entreno a esa hora',
  'workout.err.transferHttp': 'Error al reprogramar: {status}',
  'workout.err.transferNetwork': 'Error de red al reprogramar. Revisa tu conexión.',

  'workout.detail.meetingDetails': 'Detalles de la sesión',
  'workout.detail.badgeTransferred': 'Reprogramado',
  'workout.detail.badgeSkipped': 'Omitido',
  'workout.detail.editingTitle': 'Editar',
  'workout.title.pickClient': 'Elegir cliente',
  'workout.title.openClientProfile': 'Abrir perfil del cliente',
  'workout.field.dateTime': 'Fecha y hora',
  'workout.editDateTimeTitle': 'Editar fecha y hora',
  'workout.location.gymNameLabel': 'Nombre del gimnasio *',
  'workout.location.gymNamePh': 'Nombre del gimnasio',
  'workout.location.gymAddressLabel': 'Dirección',
  'workout.location.gymAddressPh': 'Dirección',
  'workout.location.notSetOption': 'Sin definir',
  'workout.location.addNewGym': '+ Añadir gimnasio',
  'workout.location.sectionTitle': 'Ubicación',
  'workout.location.pinOnline': '📍 Online',
  'workout.editLocationTitle': 'Editar ubicación',
  'workout.removeLocationTitle': 'Quitar ubicación',
  'workout.removeLocationDesc': '¿Quitar la ubicación de este entreno? No se puede deshacer.',
  'workout.addLocationTitle': 'Añadir ubicación',
  'workout.comment.fullLabel': 'Comentario de este entreno',
  'workout.comment.shortLabel': 'Comentario',
  'workout.editCommentTitle': 'Editar comentario',
  'workout.deleteCommentTitle': 'Eliminar comentario',
  'workout.deleteCommentDesc': '¿Eliminar este comentario? No se puede deshacer.',
  'workout.commentPlaceholder': 'Escribe un comentario…',
  'workout.previousWorkout': 'Entreno anterior',
  'workout.prevWorkoutNavTitle': 'Entreno completado anterior',
  'workout.nextWorkoutNavTitle': 'Entreno completado posterior',
  'workout.exerciseHistoryTitle': 'Historial del ejercicio',
  'workout.lastSession': 'Última sesión',
  'workout.workingWeight': 'Peso de trabajo',
  'workout.noHistoryData': 'Sin datos',
  'workout.duplicateExerciseTitle': 'Ejercicio ya añadido',
  'workout.duplicateExerciseDesc': '«{name}» ya está en este entreno.',
  'workout.setsLabel': 'Series',
  'workout.noSetsTitle': 'Aún no hay series',
  'workout.noSetsHint': 'Añade la primera serie para empezar',
  'workout.addFirstSet': 'Añadir primera serie',
  'workout.focusRepsTitle': 'Enfocar campo de repeticiones',
  'workout.focusWeightTitle': 'Enfocar campo de peso',
  'workout.weightInputShort': 'Peso',
  'workout.addAnotherSet': 'Añadir otra serie',
  'workout.form.editExercise': 'Editar ejercicio',
  'workout.form.addExercise': 'Añadir ejercicio',
  'workout.exerciseNameLabel': 'Nombre del ejercicio',
  'workout.tapToPickExercise': 'Toca para elegir ejercicio',
  'workout.searchExercisesShort': 'Buscar ejercicios…',
  'workout.historyGroupOnly': 'El historial solo está disponible en entrenos individuales',
  'workout.historyNoClient': 'El entreno no tiene cliente: no se puede mostrar el historial',
  'workout.setLine': 'Serie {n}: {reps} rep.',
  'workout.setWeightPart': ' × {w} kg',
  'workout.noPrevWorkoutData': 'Sin datos de la sesión anterior',
  'workout.exercisesHeading': 'Ejercicios',
  'workout.planLabel': 'Plan:',
  'workout.unknownPlan': 'Plan desconocido',
  'workout.replacePlan': 'Sustituir plan',
  'workout.replaceShort': 'Sustituir',
  'workout.addExerciseFull': 'Añadir ejercicio',
  'workout.addPlan': 'Añadir plan',
  'workout.planShort': 'Plan',
  'workout.or': 'o',
  'workout.addReadyMadePlan': 'Añadir plan guardado',
  'workout.pickTrainingPlan': 'Elegir plan de entreno',
  'workout.noPlansAvailable': 'No hay planes disponibles',
  'workout.noExercisesInPlanCard': 'Sin ejercicios',
  'workout.noExercises': 'Sin ejercicios',
  'workout.editExerciseTitle': 'Editar ejercicio',
  'workout.deleteExerciseTitle': 'Eliminar ejercicio',
  'workout.deleteExerciseConfirmTitle': '¿Seguro?',
  'workout.deleteExerciseConfirmDesc':
    'No se puede deshacer. El ejercicio se quitará de este entreno.',
  'workout.workingWeightColon': 'Peso de trabajo:',
  'workout.workingWeightGroupAlert':
    'El peso de trabajo solo se puede actualizar en entrenos individuales con cliente',
  'workout.updateWorkingWeightTitle': 'Actualizar peso de trabajo',
  'workout.updateWeightBtn': 'Actualizar peso',
  'workout.workingWeightKgLabel': 'Peso de trabajo (kg)',
  'workout.weightExamplePh': 'p. ej. 40',
  'workout.err.noWorkoutClient': 'El entreno no tiene cliente',
  'workout.err.workingWeightUpdate': 'Error al actualizar el peso de trabajo',
  'workout.restoreSession': 'Restaurar sesión',
  'workout.movedSession': 'El entreno fue reprogramado',
  'workout.cancelSession': 'Cancelar',
  'workout.markSkipBtn': 'Marcar como omitido',
  'workout.markDoneBtn': 'Marcar como completado',
  'workout.markDoneTitle': 'Marcar como completado',
  'workout.markDoneDesc': 'El entrenamiento se marcará como completado.',
  'workout.toast.markedDone': 'Entrenamiento marcado como completado',
  'workout.statusMenuAria': 'Cambiar estado del entrenamiento',
  'workout.err.statusUpdate': 'No se pudo actualizar el estado del entrenamiento',
  'workout.rescheduleTitle': 'Reprogramar',
  'workout.rescheduleMoving': 'Moviendo…',
  'workout.rescheduleValidating': 'Comprobando…',
  'workout.rescheduleSubmit': 'Reprogramar',
  'workout.rescheduleHint': 'Elige nueva fecha y hora',
  'workout.conflictTitle': 'No se pudo crear el entreno',
  'workout.conflictTimeTaken': 'Ese horario ya está reservado.',
  'workout.conflictingListTitle': 'Entrenos en conflicto:',
  'workout.clientNotSpecified': 'Cliente no indicado',
  'workout.sameSlotTitle': 'Elige otro horario',
  'workout.sameSlotDesc':
    'La fecha y hora coinciden con el entreno actual. Elige otro momento para reprogramar.',
  'workout.newDateLabel': 'Nueva fecha *',
  'workout.startTimeLabel': 'Hora de inicio *',
  'workout.endTimeLabel': 'Hora de fin',
  'workout.endTimePh': 'Igual que el original',
  'workout.durationHint':
    'Al cambiar la hora de inicio se mantiene la misma duración que este entreno',
  'workout.exerciseConfirmTitle': 'Añadir ejercicio nuevo',
  'workout.exerciseConfirmDesc':
    '«{name}» no está en tu diccionario. ¿Añadirlo a tu lista de ejercicios?',
  'workout.muscleGroupLabel': 'Grupo muscular',
  'workout.muscleGroupPh': 'Elige grupo muscular',
  'workout.dictTrainerNote': 'El ejercicio se añadirá al diccionario de este entrenador',
  'workout.pickClientHeader': 'Elegir cliente',
  'workout.openingClientWorkout': 'Abriendo entreno…',
  'workout.willOpenClientWorkout': 'Abre el entreno del cliente seleccionado',
  'workout.restoreTitle': 'Restaurar entreno',
  'workout.restoreDesc': 'El entreno volverá al estado programado.',
  'workout.restoring': 'Restaurando…',
  'workout.restore': 'Restaurar',
  'workout.cancelWorkoutTitle': 'Cancelar entreno',
  'workout.cancelThisWorkout': 'Cancelar solo este',
  'workout.cancelFutureWorkouts': 'Cancelar este y los siguientes',
  'workout.cancelling': 'Cancelando…',
  'workout.back': 'Atrás',
  'workout.skipTitle': 'Marcar como omitido',
  'workout.skipDesc':
    '¿Marcar este entreno como omitido? Se descontará como una sesión completada.',
  'workout.markingSkip': 'Marcando…',
  'workout.addToDictButton': 'Añadir «{name}»',
  'workout.conflictOverlapFallback': 'Este horario se solapa con otros entrenos',
};
